<style lang="scss" scoped>
.image {
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.cross-fade-enter,
.cross-fade-leave-to {
  opacity: 0;
}

.cross-fade-enter-active,
.cross-fade-leave-active {
  transition: opacity 0.3s linear;
}

.cross-fade-enter-to,
.cross-fade-leave {
  opacity: 1;
}

.container {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container #location-card.card {
  flex-grow: 1;
  // height: 54px;
}

#location-card.card .card-content {
  padding: 6px 12px;
  margin: 48px 0;
}

input[type='text'] {
  border: 0;
  margin-bottom: 0;
  font-size: 0.8em;
}

#location {
  box-shadow: none !important;
  border: 0 !important;
}

.title {
  font-size: 3.5em;
  font-weight: 200;
  color: white;
  text-align: center;
  margin: 0 !important;
  line-height: 1;
  letter-spacing: 0;

  span {
    color: #ffc5c5;
  }

  span.alternate {
    color: #e86363;
  }
}

.billboard {
  > div {
    height: inherit;
  }
}
// #autosuggest >.inputAutocomplete{
//       background: white;
//       border-bottom: 0 !important;
//     }

/* Extra Small Devices, Phones */
@media only screen and (max-width: 480px) {
  .title {
    font-size: 2.5em;
  }
}
</style>
<style lang="scss">
#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  font-weight: 400;
  font-size: 20px;
  // border: 1px solid #616161;
  border-bottom: none !important;
  margin: 0;
  padding: 15px;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}
#autosuggest__input:focus {
  border-bottom: none !important;
  box-shadow: none !important;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  // overflow: scroll;
  max-height: 280px;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results_item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results_title {
  border-top: none;
}

.autosuggest__results .autosuggest__results_title {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results_item:active,
.autosuggest__results .autosuggest__results_item:hover,
.autosuggest__results .autosuggest__results_item:focus,
.autosuggest__results
  .autosuggest__results_item.autosuggest__results_item-highlighted {
  background-color: #ddd;
}
.search-box-panel {
  width: 100%;
  max-width: 800px;
}
.search-box-panel p.title {
  font-size: 3em !important;
  line-height: 3rem;
}
</style>

<template lang="pug">
div
  v-container
    .search-box-panel
      p.title.big
        span Whisky
        | ,
        span
          |
          | Wine
        | ,
        span
          |
          | Beer
        | , and
        span
          |
          | Beverage.
      p.title.big Delivered
        span.alternate
          |
          | straight to you.

      #location-card.card
        vue-autosuggest(
          v-model='query',
          :suggestions='filteredOptions',
          @focus='focusMe',
          @click='clickHandler',
          @input='onInputChange',
          @selected='onSelected',
          :get-suggestion-value='getSuggestionValue',
          :input-props='{ id: "autosuggest__input", placeholder: "Find your drinks here!" }'
        )

      div(slot-scope='{ suggestion }')
        img(:src='suggestion.item.avatar')
        div {{ suggestion.item.name }}

  transition(name='cross-fade')
    .image(
      :key='backgroundIndex',
      :style='{ backgroundImage: "url(" + backgrounds[backgroundIndex] + ")" }'
    )
      //- here
</template>
<script>
/* eslint-disable no-undef */
import axios from 'axios'
// import debounce from 'debounce'
import InputLocationAutocomplete from '@/components/input-location-autocomplete'
import { VueAutosuggest } from 'vue-autosuggest'

export default {
  data() {
    return {
      location: null,
      backgroundIndex: 0,
      bgChange: null,
      searchListener: null,
      predictedcities: {},
      citiesAutocomplete: null,
      selected: '',
      inputProps: {
        id: 'autosuggest__input',
        onInputChange: this.onInputChange,
        placeholder: 'Enter Product',
        class: 'inputAutocomplete',
      },
      limit: 10,
      drinks: [{ data: [] }],
      samplearry: [],
      query: '',
    }
  },
  created() {
    this.getDrinks()
  },
  watch: {
    '$route.params'() {
      this.updateModal()
    },
    '$store.state.cart.location'() {
      this.getDrinks()
    },
  },
  mounted() {
    if (this.backgrounds.length) {
      this.bgChange = setInterval(() => {
        this.backgroundIndex =
          (this.backgroundIndex + 1) % this.backgrounds.length
      }, 5000)
    }

    // this.initializeInput()
  },
  destroyed() {
    clearInterval(this.bgChange)
  },
  computed: {
    backgrounds() {
      return [
        // require('./../assets/img/banner-1.jpg'),
        // require('./../assets/img/banner-2.jpg'),
        require('./../assets/img/banner-3.jpg'),
      ]
    },
    drinksList() {
      var formatted = []
      for (var i = 0; i < this.drink.length; i++) {
        formatted[i] = { discountId: this.drink[i]['name'] }
      }
      return formatted
    },
    filteredOptions() {
      return [
        {
          data: this.drinks[0].data.filter((option) => {
            return option.toLowerCase().indexOf(this.query.toLowerCase()) > -1
          }),
        },
      ]
    },
  },
  methods: {
    // initializeInput () {
    //   this.searchListener = debounce(this.getcities, 500)
    //   this.$refs.location.addEventListener('keyup', this.searchListener)

    //   this.citiesAutocomplete = this.$M.Autocomplete.init(this.$refs.location, {
    //     data: this.predictedcities,
    //     onAutocomplete: (val) => {

    //     }
    //   })
    // },
    getDrinks() {
      axios
        .get(`${this.$config.API_URL}/products/`, {
          params: {
            ...this.$route.query,
            location: this.$store.state.cart.location,
          },
        })
        .then((result) => {
          for (let i = 0; i < result.data.length; i++) {
            if (this.drinks[0]['data'].indexOf(result.data[i]['name']) === -1) {
              this.drinks[0]['data'].push(result.data[i]['name'])
            }
          }
        })
    },
    onLocationAutocomplete(location) {
      this.$store.dispatch('cart/setLocation', location)
      this.$router.push({ name: 'drinks' })
    },
    onProductAutocomplate(data) {},
    // onSelected(option) {
    //   this.selected = option.item;
    //   let query = {
    //     ...this.$route.query,
    //     name: this.selected
    //   };
    //   this.$router.push({ name: "drinks", query: query });
    // },
    // onInputChange(text) {
    //   if (text === "" || text === undefined) {
    //     return;
    //   }
    //   /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
    //   // const filteredData = this.options[0].data.filter(item => {
    //   const filteredData = this.drinks[0].data
    //     .filter(item => {
    //       return item.toLowerCase().indexOf(text.toLowerCase()) > -1;
    //     })
    //     .slice(0, this.limit);
    //   this.filteredOptions = [
    //     {
    //       data: filteredData
    //     }
    //   ];
    // },
    getcities() {
      return axios
        .get(`${this.$config.API_URL}/config/places`, {
          params: {
            type: 'location',
            place: this.location,
          },
        })
        .then((result) => {
          if (result) {
            this.predictedcities = {}

            for (let i = 0; i < result.data.data.length; i++) {
              this.predictedcities[result.data.data[i]] = null
            }
            this.citiesAutocomplete.updateData(this.predictedcities)
            this.citiesAutocomplete.open()
          }
        })
    },

    clickHandler(item) {
      // event fired when clicking on the input
    },
    onSelected(item) {
      this.selected = item.item
      let query = {
        ...this.$route.query,
        name: this.selected,
      }
      this.$router.push({ name: 'drinks', query: query })
    },
    onInputChange(text) {
      // event fired when the input changes
    },
    /**
     * This is what the <input/> value is set to when you are selecting a suggestion.
     */
    getSuggestionValue(suggestion) {
      return suggestion.item.name
    },
    focusMe(e) {},
  },
  components: {
    InputLocationAutocomplete,
    VueAutosuggest,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/page-home-billboard.vue